import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  Navigate,
} from "react-router-dom";
import Vaceai from "./pages/Vaceai";
import NewInterview from './interview/pages/NewInterview';
import InterviewQuestions from "./interview/pages/InterviewQuestions";
import WebcamPage from "./interview/pages/WebcamPage";
import QuestionEvaluation from "./interview/pages/QuestionEvaluation";
import QuestionAnswer from "./interview/pages/QuestionAnswer";
import EvaluationReport from "./interview/pages/EvaluationReport";
import Users from './user/pages/Users';
import Account from "./user/pages/Account";
import Upgrade from "./user/pages/Upgrade";
import Waitlist from './user/pages/Waitlist';
import Auth from './user/pages/Auth';
import NewPassword from './user/pages/NewPassword';
import ResetPassword from './user/pages/ResetPassword';
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import { AuthContext } from './shared/context/auth-context';
import { useAuth } from './shared/hooks/auth-hook';
import Home from "./interview/pages/Home";

function App() {
  const { token, userId, login, logout } = useAuth();
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  let routes;

  if (token) {
    routes = <Routes>
      <Route path="/success/:plan/:userId" exact element={<Success />} />
      <Route path="/account" exact element={<Account />} />
      <Route path="/home" exact element={<Home />} />
      <Route path="/upgrade" exact element={<Upgrade />} />
      <Route path="/cancel" element={<Cancel />} />
      <Route path="/new" element={<NewInterview />} />
      <Route path='/user/:userId/detail' exact element={<Users />} />
      <Route path='/interview/:interviewId/questions' exact element={<InterviewQuestions />} />
      <Route path="/webcam/:questionId/:question" exact element={<WebcamPage />} />
      <Route path='/question/evaluation/:questionId' exact element={<QuestionEvaluation />} />
      <Route path='/question/answer/:questionId/:question' exact element={<QuestionAnswer />} />
      <Route path='/question/report/evaluation/:evaluationId' exact element={<EvaluationReport />} />
      <Route path="*" element={<Navigate to ="/home" />}/>
    </Routes>
  }
  else {
    routes = <Routes>
      <Route path="/" exact element={<Vaceai />} />
      <Route path="/success/:plan/:userId" exact element={<Success />} />
      <Route path="/cancel" element={<Cancel />} />
      <Route path="/auth" element={<Auth/>} />
      <Route path="/waitlist" exact element={<Waitlist/>} />
      <Route path="/reset" exact element={<ResetPassword/>}/>
      <Route path="/newpassword/:token" exact element={<NewPassword/>}/>
      <Route path="*" element={<Navigate to ="/" />}/>
    </Routes>
    
  }
  return (
    <AuthContext.Provider value={{isLoggedIn:!!token, token: token, userId:userId, login:login, logout:logout}}>
        <main>{routes}</main>
    </AuthContext.Provider>
  );
}
export default App;
